import React, { useState, useEffect } from 'react';
import CheckboxItem from './CheckboxItem';

export interface Option {
  label: string;
  value: string | number | boolean;
}

interface Props<T extends Option> {
  options: T[];
  defaultValue?: T['value'];
  value?: T['value'];
  colon?: boolean;
  onChange?: (option: T) => void;
}

function RadioGroupItems<T extends Option = Option>(props: Props<T>) {
  const { options, defaultValue, value, onChange, colon = false } = props;
  const [currentValue, setCurrentValue] = useState(defaultValue);

  useEffect(() => {
    if (typeof value !== 'undefined') {
      setCurrentValue(value);
    }
  }, [value]);

  const handleChange = (targetValue: any) => (checked: boolean) => {
    if (checked && typeof value === 'undefined') {
      // 非受控时
      setCurrentValue(targetValue);
    }

    if (onChange) {
      const target = options.find(option => option.value === targetValue);

      if (target) {
        onChange(target);
      }
    }
  };

  return (
    <>
      {options.map(option => (
        <CheckboxItem
          colon={colon}
          key={option.value.toString()}
          title={option.label}
          checked={currentValue === option.value}
          onChange={handleChange(option.value)}
        />
      ))}
    </>
  );
}

export default RadioGroupItems;
